/* eslint-disable */

import * as customerManagementService from "../../services/customer";
import * as settings from "../../services/settings";

import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Col, Row, Table, notification } from "antd";
import React, { useCallback, useEffect, useState } from "react";

import { Spin } from "antd";
import permissions from "../../../configs/permission";
import { useAccessToken } from "../../contexts/AccessTokenContext";
import { usePermission } from "../../hooks/usePermission";
import { formatNumber } from "../model/formatNumber";
import { ModalDelete } from "../model/modal/delete";
import { ModelFormula } from "./modal/modalFormula";

const initPage = { limit: 10, page: 1, total: 1 };

export const CreateCustomerFormula = ({ t, detailData, formulaRefreshKey = 0 }) => {
  const { hasPermission, isSuperuser } = usePermission();
  const { accessToken } = useAccessToken();
  const [search, setSearch] = useState(initPage);
  const [customerFormulaData, setCustomerFormulaData] = useState([]);
  const [viewFormulaDataByOne, setViewFormulaData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [prepareDeleteData, setPrepareDeleteData] = useState({});

  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, message, description) => {
    api[type]({
      message: message,
      description: description,
    });
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onDeleteCustomerFormula = async (data) => {
    setLoading(true);
    try {
      await customerManagementService.deleteCustomerFormula(accessToken, data.id, {});
      openNotificationWithIcon(settings.NotificationType.SUCCESS, <>{"Success."}</>, <>{"Delete formula success"}</>);
      setPrepareDeleteData({});
      setIsOpenDelete(false);
      fetchCompanyFormula();
      setLoading(false);
    } catch (err) {
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      console.error("[CreateCustomerFormula] onDeleteCustomerFormula: ", err);
      setLoading(false);
    }
  };

  const fetchCustomerFormula = useCallback(
    async (param) => {
      setLoading(true);
      const params = { ...param };
      let getById = detailData.id;
      try {
        const data = await customerManagementService.getCompanyFormula(accessToken, getById, params);
        setCustomerFormulaData(data);
        setSearch({ ...param });
      } catch (err) {
        console.error("[CreateCustomerFormula] fetchCustomerFormula: ", err);
        const { message } = settings.getErrorMessage(err);
        openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
        setLoading(false);
      }
      setLoading(false);
    },
    [accessToken, detailData?.id]
  );

  useEffect(() => {
    if (!accessToken || !detailData?.id) return;
    fetchCustomerFormula();
  }, [accessToken, fetchCustomerFormula, formulaRefreshKey, detailData?.id]);

  const columns = [
    {
      title: () => {
        return <>{t("Customer_Table.No")}</>;
      },
      dataIndex: "id",
      key: "id",
      width: "100px",
    },
    {
      title: () => {
        return <>{t("Customer_Table.Origin")}</>;
      },
      dataIndex: "origin",
      key: "origin",
      width: "100px",
      render: (_, record) => {
        const origin = record.app_warehouse_app_customerformula_origin_idToapp_warehouse.warehouse_code || "";
        return <p>{origin}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Table.Destination")}</>;
      },
      dataIndex: "destination",
      key: "destination",
      width: "150px",
      render: (_, record) => {
        const destination = record.app_warehouse_app_customerformula_destination_idToapp_warehouse.warehouse_code || "";
        return <p>{destination}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Threshold_A")}</>;
      },
      width: "120px",
      dataIndex: "threshold_a",
      key: "threshold_a",
      render: (_, record) => {
        const threshold_a = record.threshold_a || "";
        return <p>{formatNumber(threshold_a)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Threshold_B")}</>;
      },
      dataIndex: "threshold_b",
      key: "threshold_b",
      width: "120px",
      render: (_, record) => {
        const threshold_b = record.threshold_b || "";
        return <p>{formatNumber(threshold_b)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Threshold_C")}</>;
      },
      width: "120px",
      dataIndex: "threshold_c",
      key: "threshold_c",
      render: (_, record) => {
        const threshold_c = record.threshold_c || "";
        return <p>{formatNumber(threshold_c)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Threshold_D")}</>;
      },
      width: "120px",
      dataIndex: "threshold_d",
      key: "threshold_d",
      render: (_, record) => {
        const threshold_d = record.threshold_d || "";
        return <p>{formatNumber(threshold_d)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Threshold_E")}</>;
      },
      width: "120px",
      dataIndex: "threshold_e",
      key: "threshold_e",
      render: (_, record) => {
        const threshold_e = record.threshold_e || "";
        return <p>{formatNumber(threshold_e)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Formula_Volume_Sea.Volume_Form")}</>;
      },
      width: "120px",
      dataIndex: "volume_sea_from",
      key: "volume_sea_from",
      className: "bg-table-light-blue",
      render: (_, record) => {
        const app_customervolumeformula = record.app_customervolumeformula;
        let volume_from = 0;
        if (app_customervolumeformula) {
          app_customervolumeformula.map((element) => {
            if (element.route == "sea") {
              volume_from = element.volume_from;
            }
          });
        }
        return <p>{formatNumber(volume_from)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Formula_Volume_Sea.Volume_To")}</>;
      },
      width: "120px",
      dataIndex: "volume_sea_to",
      key: "volume_sea_to",
      className: "bg-table-light-blue",
      render: (_, record) => {
        const app_customervolumeformula = record.app_customervolumeformula;
        let volume_to = 0;
        if (app_customervolumeformula) {
          app_customervolumeformula.map((element) => {
            if (element.route == "sea") {
              volume_to = element.volume_to;
            }
          });
        }
        return <p>{formatNumber(volume_to)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Formula_Volume_Sea.A")}</>;
      },
      width: "120px",
      dataIndex: "volume_sea_a",
      key: "volume_sea_a",
      className: "bg-table-light-blue",
      render: (_, record) => {
        const app_customervolumeformula = record.app_customervolumeformula;
        let volume_a = 0;
        if (app_customervolumeformula) {
          app_customervolumeformula.map((element) => {
            if (element.route == "sea") {
              volume_a = element.a;
            }
          });
        }
        return <p>{formatNumber(volume_a)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Formula_Volume_Sea.B")}</>;
      },
      width: "120px",
      dataIndex: "volume_sea_b",
      key: "volume_sea_b",
      className: "bg-table-light-blue",
      render: (_, record) => {
        const app_customervolumeformula = record.app_customervolumeformula;
        let volume_b = 0;
        if (app_customervolumeformula) {
          app_customervolumeformula.map((element) => {
            if (element.route == "sea") {
              volume_b = element.b;
            }
          });
        }
        return <p>{formatNumber(volume_b)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Formula_Volume_Sea.C")}</>;
      },
      width: "120px",
      dataIndex: "volume_sea_c",
      key: "volume_sea_c",
      className: "bg-table-light-blue",
      render: (_, record) => {
        const app_customervolumeformula = record.app_customervolumeformula;
        let volume_c = 0;
        if (app_customervolumeformula) {
          app_customervolumeformula.map((element) => {
            if (element.route == "sea") {
              volume_c = element.c;
            }
          });
        }
        return <p>{formatNumber(volume_c)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Formula_Volume_Sea.D")}</>;
      },
      width: "120px",
      dataIndex: "volume_sea_d",
      key: "volume_sea_d",
      className: "bg-table-light-blue",
      render: (_, record) => {
        const app_customervolumeformula = record.app_customervolumeformula;
        let volume_d = 0;
        if (app_customervolumeformula) {
          app_customervolumeformula.map((element) => {
            if (element.route == "sea") {
              volume_d = element.d;
            }
          });
        }
        return <p>{formatNumber(volume_d)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Formula_Volume_Sea.E")}</>;
      },
      width: "120px",
      dataIndex: "volume_sea_e",
      key: "volume_sea_e",
      className: "bg-table-light-blue",
      render: (_, record) => {
        const app_customervolumeformula = record.app_customervolumeformula;
        let volume_e = 0;
        if (app_customervolumeformula) {
          app_customervolumeformula.map((element) => {
            if (element.route == "sea") {
              volume_e = element.e;
            }
          });
        }
        return <p>{formatNumber(volume_e)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Formula_Volume_Land.Volume_Form")}</>;
      },
      width: "120px",
      dataIndex: "volume_land_from",
      key: "volume_land_from",
      className: "bg-table-light-red",
      render: (_, record) => {
        const app_customervolumeformula = record.app_customervolumeformula;
        let volume_from = 0;
        if (app_customervolumeformula) {
          app_customervolumeformula.map((element) => {
            if (element.route == "land") {
              volume_from = element.volume_from;
            }
          });
        }
        return <p>{formatNumber(volume_from)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Formula_Volume_Land.Volume_To")}</>;
      },
      width: "120px",
      dataIndex: "volume_land_to",
      key: "volume_land_to",
      className: "bg-table-light-red",
      render: (_, record) => {
        const app_customervolumeformula = record.app_customervolumeformula;
        let volume_to = 0;
        if (app_customervolumeformula) {
          app_customervolumeformula.map((element) => {
            if (element.route == "land") {
              volume_to = element.volume_to;
            }
          });
        }
        return <p>{formatNumber(volume_to)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Formula_Volume_Land.A")}</>;
      },
      width: "120px",
      dataIndex: "volume_land_a",
      key: "volume_land_a",
      className: "bg-table-light-red",
      render: (_, record) => {
        const app_customervolumeformula = record.app_customervolumeformula;
        let volume_a = 0;
        if (app_customervolumeformula) {
          app_customervolumeformula.map((element) => {
            if (element.route == "land") {
              volume_a = element.a;
            }
          });
        }
        return <p>{formatNumber(volume_a)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Formula_Volume_Land.B")}</>;
      },
      width: "120px",
      dataIndex: "volume_land_b",
      key: "volume_land_b",
      className: "bg-table-light-red",
      render: (_, record) => {
        const app_customervolumeformula = record.app_customervolumeformula;
        let volume_b = 0;
        if (app_customervolumeformula) {
          app_customervolumeformula.map((element) => {
            if (element.route == "land") {
              volume_b = element.b;
            }
          });
        }
        return <p>{formatNumber(volume_b)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Formula_Volume_Land.C")}</>;
      },
      width: "120px",
      dataIndex: "volume_land_c",
      key: "volume_land_c",
      className: "bg-table-light-red",
      render: (_, record) => {
        const app_customervolumeformula = record.app_customervolumeformula;
        let volume_c = 0;
        if (app_customervolumeformula) {
          app_customervolumeformula.map((element) => {
            if (element.route == "land") {
              volume_c = element.c;
            }
          });
        }
        return <p>{formatNumber(volume_c)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Formula_Volume_Land.D")}</>;
      },
      width: "120px",
      dataIndex: "volume_land_d",
      key: "volume_land_d",
      className: "bg-table-light-red",
      render: (_, record) => {
        const app_customervolumeformula = record.app_customervolumeformula;
        let volume_d = 0;
        if (app_customervolumeformula) {
          app_customervolumeformula.map((element) => {
            if (element.route == "land") {
              volume_d = element.d;
            }
          });
        }
        return <p>{formatNumber(volume_d)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Formula_Volume_Land.E")}</>;
      },
      width: "120px",
      dataIndex: "volume_land_e",
      key: "volume_land_e",
      className: "bg-table-light-red",
      render: (_, record) => {
        const app_customervolumeformula = record.app_customervolumeformula;
        let volume_e = 0;
        if (app_customervolumeformula) {
          app_customervolumeformula.map((element) => {
            if (element.route == "land") {
              volume_e = element.e;
            }
          });
        }
        return <p>{formatNumber(volume_e)}</p>;
      },
    },
    //
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Formula_Weight_Sea.Weight_Form")}</>;
      },
      width: "120px",
      dataIndex: "weight_sea_from",
      key: "weight_sea_from",
      className: "bg-table-light-blue",
      render: (_, record) => {
        const app_customerweigthformula = record.app_customerweightformula;
        let weight_from = 0;
        if (app_customerweigthformula) {
          app_customerweigthformula.map((element) => {
            if (element.route == "sea") {
              weight_from = element.weight_from;
            }
          });
        }
        return <p>{formatNumber(weight_from)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Formula_Weight_Sea.Weight_To")}</>;
      },
      width: "120px",
      dataIndex: "weight_sea_to",
      key: "weight_sea_to",
      className: "bg-table-light-blue",
      render: (_, record) => {
        const app_customerweigthformula = record.app_customerweightformula;
        let weight_to = 0;
        if (app_customerweigthformula) {
          app_customerweigthformula.map((element) => {
            if (element.route == "sea") {
              weight_to = element.weight_to;
            }
          });
        }
        return <p>{formatNumber(weight_to)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Formula_Weight_Sea.A")}</>;
      },
      width: "120px",
      dataIndex: "weight_sea_a",
      key: "weight_sea_a",
      className: "bg-table-light-blue",
      render: (_, record) => {
        const app_customerweigthformula = record.app_customerweightformula;
        let weight_a = 0;
        if (app_customerweigthformula) {
          app_customerweigthformula.map((element) => {
            if (element.route == "sea") {
              weight_a = element.a;
            }
          });
        }
        return <p>{formatNumber(weight_a)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Formula_Weight_Sea.B")}</>;
      },
      width: "120px",
      dataIndex: "weight_sea_b",
      key: "weight_sea_b",
      className: "bg-table-light-blue",
      render: (_, record) => {
        const app_customerweigthformula = record.app_customerweightformula;
        let weight_b = 0;
        if (app_customerweigthformula) {
          app_customerweigthformula.map((element) => {
            if (element.route == "sea") {
              weight_b = element.b;
            }
          });
        }
        return <p>{formatNumber(weight_b)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Formula_Weight_Sea.C")}</>;
      },
      width: "120px",
      dataIndex: "weight_sea_c",
      key: "weight_sea_c",
      className: "bg-table-light-blue",
      render: (_, record) => {
        const app_customerweigthformula = record.app_customerweightformula;
        let weight_c = 0;
        if (app_customerweigthformula) {
          app_customerweigthformula.map((element) => {
            if (element.route == "sea") {
              weight_c = element.c;
            }
          });
        }
        return <p>{formatNumber(weight_c)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Formula_Weight_Sea.D")}</>;
      },
      width: "120px",
      dataIndex: "weight_sea_d",
      key: "weight_sea_d",
      className: "bg-table-light-blue",
      render: (_, record) => {
        const app_customerweigthformula = record.app_customerweightformula;
        let weight_d = 0;
        if (app_customerweigthformula) {
          app_customerweigthformula.map((element) => {
            if (element.route == "sea") {
              weight_d = element.d;
            }
          });
        }
        return <p>{formatNumber(weight_d)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Formula_Weight_Sea.E")}</>;
      },
      width: "120px",
      dataIndex: "weight_sea_e",
      key: "weight_sea_e",
      className: "bg-table-light-blue",
      render: (_, record) => {
        const app_customerweigthformula = record.app_customerweightformula;
        let weight_e = 0;
        if (app_customerweigthformula) {
          app_customerweigthformula.map((element) => {
            if (element.route == "sea") {
              weight_e = element.e;
            }
          });
        }
        return <p>{formatNumber(weight_e)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Formula_Weight_Land.Weight_Form")}</>;
      },
      width: "120px",
      dataIndex: "weight_land_from",
      key: "weight_land_from",
      className: "bg-table-light-red",
      render: (_, record) => {
        const app_customerweightformula = record.app_customerweightformula;
        let weight_from = 0;
        if (app_customerweightformula) {
          app_customerweightformula.map((element) => {
            if (element.route == "land") {
              weight_from = element.weight_from;
            }
          });
        }
        return <p>{formatNumber(weight_from)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Formula_Weight_Land.Weight_To")}</>;
      },
      width: "120px",
      dataIndex: "weight_land_to",
      key: "weight_land_to",
      className: "bg-table-light-red",
      render: (_, record) => {
        const app_customerweightformula = record.app_customerweightformula;
        let weight_to = 0;
        if (app_customerweightformula) {
          app_customerweightformula.map((element) => {
            if (element.route == "land") {
              weight_to = element.weight_to;
            }
          });
        }
        return <p>{formatNumber(weight_to)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Formula_Weight_Land.A")}</>;
      },
      width: "120px",
      dataIndex: "weight_land_a",
      key: "weight_land_a",
      className: "bg-table-light-red",
      render: (_, record) => {
        const app_customerweightformula = record.app_customerweightformula;
        let weight_a = 0;
        if (app_customerweightformula) {
          app_customerweightformula.map((element) => {
            if (element.route == "land") {
              weight_a = element.a;
            }
          });
        }
        return <p>{formatNumber(weight_a)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Formula_Weight_Land.B")}</>;
      },
      width: "120px",
      dataIndex: "weight_land_b",
      key: "weight_land_b",
      className: "bg-table-light-red",
      render: (_, record) => {
        const app_customerweightformula = record.app_customerweightformula;
        let weight_b = 0;
        if (app_customerweightformula) {
          app_customerweightformula.map((element) => {
            if (element.route == "land") {
              weight_b = element.b;
            }
          });
        }
        return <p>{formatNumber(weight_b)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Formula_Weight_Land.C")}</>;
      },
      width: "120px",
      dataIndex: "weight_land_c",
      key: "weight_land_c",
      className: "bg-table-light-red",
      render: (_, record) => {
        const app_customerweightformula = record.app_customerweightformula;
        let weight_c = 0;
        if (app_customerweightformula) {
          app_customerweightformula.map((element) => {
            if (element.route == "land") {
              weight_c = element.c;
            }
          });
        }
        return <p>{formatNumber(weight_c)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Formula_Weight_Land.D")}</>;
      },
      width: "120px",
      dataIndex: "weight_land_d",
      key: "weight_land_d",
      className: "bg-table-light-red",
      render: (_, record) => {
        const app_customerweightformula = record.app_customerweightformula;
        let weight_d = 0;
        if (app_customerweightformula) {
          app_customerweightformula.map((element) => {
            if (element.route == "land") {
              weight_d = element.d;
            }
          });
        }
        return <p>{formatNumber(weight_d)}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Customer_Create.Create_Formula.Formula_Weight_Land.E")}</>;
      },
      width: "120px",
      dataIndex: "weight_land_e",
      key: "weight_land_e",
      className: "bg-table-light-red",
      render: (_, record) => {
        const app_customerweightformula = record.app_customerweightformula;
        let weight_e = 0;
        if (app_customerweightformula) {
          app_customerweightformula.map((element) => {
            if (element.route == "land") {
              weight_e = element.e;
            }
          });
        }
        return <p>{formatNumber(weight_e)}</p>;
      },
    },
    //
    {
      title: t("Customer_Table.Edit"),
      width: "100px",
      dataIndex: "edit",
      key: "edit",
      render: (_, record) => (
        <Button
          type="link"
          disabled={!hasPermission(permissions.CustomerFormula?.CHANGE)}
          onClick={() => {
            setViewFormulaData(record);
            showModal();
          }}
        >
          <EditOutlined />
        </Button>
      ),
    },
    {
      title: t("Customer_Table.Is_Delete"),
      width: "100px",
      dataIndex: "delete",
      key: "delete",
      render: (_, record) => (
        <Button
          type="link"
          disabled={!hasPermission(permissions.CustomerFormula?.DELETE)}
          onClick={() => {
            setIsOpenDelete(true);
            setPrepareDeleteData(record);
          }}
        >
          <DeleteOutlined />
        </Button>
      ),
    },
  ];

  return (
    <>
      {contextHolder}
      <Spin spinning={loading}>
        <Row align="middle" justify="end">
          <Col span={24}>
            <Table
              columns={columns}
              dataSource={customerFormulaData}
              scroll={{ x: "1440px", y: "500px" }}
              rowKey={(record) => record.id}
              pagination={{
                defaultPageSize: search.limit,
                current: search.page,
                pageSize: search.limit,
                total: search.total,
                onChange: (page, limit) => {
                  fetchCustomerFormula({ ...search, page, limit });
                },
                showSizeChanger: true,
              }}
              style={{ cursor: "pointer" }}
            />
          </Col>
          <Col span={24}>
            <div className="flex justify-end mt-2">
              <Button type="primary" onClick={() => fetchCustomerFormula()}>
                {t("BTN_Reload", { ns: "buttons" })}
              </Button>
            </div>
          </Col>
        </Row>
        <ModelFormula
          isModalOpen={isModalOpen}
          handleOk={handleOk}
          viewFormulaDataByOne={viewFormulaDataByOne}
          handleCancel={handleCancel}
          fetchCustomerFormula={fetchCustomerFormula}
          setIsModalOpen={setIsModalOpen}
          detailData={detailData}
          t={t}
        />
        <ModalDelete
          isOpen={isOpenDelete}
          handleCloseModal={() => {
            setIsOpenDelete(false);
          }}
          onClick={() => {
            onDeleteCustomerFormula(prepareDeleteData);
          }}
          dataDetail={prepareDeleteData}
          t={t}
        />
      </Spin>
    </>
  );
};
